import { render, staticRenderFns } from "./ComponentGap.vue?vue&type=template&id=7636b597&scoped=true&"
import script from "./ComponentGap.vue?vue&type=script&lang=js&"
export * from "./ComponentGap.vue?vue&type=script&lang=js&"
import style0 from "./ComponentGap.vue?vue&type=style&index=0&id=7636b597&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636b597",
  null
  
)

export default component.exports